import React, { useState, useEffect } from 'react';
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout, Spin } from "antd";
import { LoginPage } from "./pages/auth/loginPage.jsx";
import { Sidebar } from "./components/Sidebar/index.jsx";
import { TopBar } from "./components/TopBar/index.jsx";
import { LockScreen } from "./components/Dialog/lockscreen-dialog.jsx";
import { ErrorDialog } from "./components/Dialog/error-dialog.jsx";
import { SuccessDialog } from "./components/Dialog/success-dialog.jsx";
import { CollectPage } from "./pages/collect/collect-page.jsx";
import { CashinPage } from "./pages/cashin/cashin-page.jsx";
import { BillSenelecPage } from "./pages/bills/bill-sn/bill-senelec-page.jsx";
import { BillSeneauPage } from "./pages/bills/bill-sn/bill-seneau-page.jsx";
import { CashoutCostumerPage } from "./pages/cashout/cashout-customer-page.jsx";
import { CashoutCodePage } from "./pages/cashout/cashout-code-page.jsx";
import { CashoutCardPage } from "./pages/cashout/cashout-card-page.jsx";
import { CashoutProvisionPage } from "./pages/cashout/cashout-provision-page.jsx";
import { TransfertPage } from "./pages/transfert/transfert-page.jsx";
import { BillRapidoPage } from "./pages/bills/bill-sn/bill-rapido-page.jsx";
import { BillToubaCaKanamPage } from "./pages/bills/bill-sn/bill-touba-ca-kanam-page.jsx";
import { BillBboxxPage } from "./pages/bills/bill-bf/bill-bboxx-page.jsx";
import { AirtimeOrange } from "./pages/airtime/airtime-sn/airtime-orange-page.jsx";
import { AirtimeFree } from "./pages/airtime/airtime-sn/airtime-free-page.jsx";
import { AirtimeExpresso } from "./pages/airtime/airtime-sn/airtime-expresso-page.jsx";
import { AirtimePromobile } from "./pages/airtime/airtime-sn/airtime-promobile-page.jsx";
import { AirtimeTelecelBf } from "./pages/airtime/airtime-bf/airtime-telecel-page.jsx";
import { AirtimeTelemobBf } from "./pages/airtime/airtime-bf/airtime-telemob-page.jsx";
import { AirtimeMalitel } from "./pages/airtime/airtime-ml/airtime-malitel-page.jsx";
import { AirtimeMtn } from "./pages/airtime/airtime-ci/airtime-mtn-page.jsx";
import { AirtimeMoov } from "./pages/airtime/airtime-ci/airtime-moov-page.jsx";
import { BillSodeciPage } from "./pages/bills/bill-ci/bill-soceci-page.jsx";
import { BillCiePage } from "./pages/bills/bill-ci/bill-cie-page.jsx";
import { BillWoyofalPage } from "./pages/bills/bill-sn/bill-woyofal-page.jsx";
import { BillDstvPage } from "./pages/bills/bill-sn/bill-dstv-page.jsx";
import { BillOoluPage } from "./pages/bills/bill-sn/bill-oolu-page.jsx";
import { BillDerPage } from "./pages/bills/bill-sn/bill-der-page.jsx";
import { BillCampusenPage } from "./pages/bills/bill-sn/bill-campusen-page.jsx";
import { Transaction } from "./pages/transaction/index.jsx";
import { BillAnsambleLFJMPage } from "./pages/bills/bill-sn/bill-ansamble-lfjm-page.jsx";
import { BillAnsambleLISDPage } from "./pages/bills/bill-sn/bill-ansamble-isd-page.jsx";
import { BillDiobassPage } from "./pages/bills/bill-sn/bill-diobass-page.jsx";
import BillSomagepPage from "./pages/bills/bill-ml/bill-somegep-page.jsx";
import { BillMinteroutePage } from "./pages/bills/bill-mintroute-page.jsx";
import { ActivatePage } from "./pages/auth/activatePage.jsx";
import BillCanalPage from "./pages/bills/bill-ml/bill-canal-page.jsx";
import BillIsagoPage from "./pages/bills/bill-ml/bill-isago-page.jsx";
import { HomePage } from "./pages/home/index";
import { loadAgentState } from "./redux/loadStorage.js";
import { PinSettedDialog } from "./components/Dialog/pinSetted-dialog.jsx";
import { PinCodeResetPage } from "./pages/pincode-reset/index";
import BillSaarPage from "./pages/bills/bill-sn/bill-saar-page.jsx";
import BillFaarfPage from "./pages/bills/bill-bf/bill-faarf-page.jsx";
import BillDGIDPage from "./pages/bills/bill-sn/bill-dgid-page.jsx";
import BillCmacgmPage from "./pages/bills/bill-sn/bill-cmacgm-page.jsx";
import BillOrbusPage from "./pages/bills/bill-sn/bill-orbus-page.jsx";
import BillSonabelPOSTPAIDPage from "./pages/bills/bill-bf/bill-sonabel-postpaid-page.jsx";
import BillSonabelPREPAIDPage from "./pages/bills/bill-bf/bill-sonabel-prepaid-page.jsx";
import BillAgrivoucherPage from "./pages/bills/bill-bf/bill-agrivoucher-page.jsx";
import BillAgrivoucherEnlevementPage from "./pages/bills/bill-bf/bill-agrivoucher-enlevement-page.jsx";
import CashoutMorePage from "./pages/cashout/cashout-more-page.jsx";
import { BillOneaPage } from "./pages/bills/bill-bf/bill-onea-page.jsx";
import { featuresFiltered } from './utils/globalVars.js';
import BillCollectePage from './pages/bills/bill-collecte-page.jsx';
import BillCarteRoutePage from './pages/bills/bill-carte-reload-page.jsx';
import BillBaloonPage from './pages/bills/bill-sn/bill-baloon/bill-baloon-page.jsx';

const { Content } = Layout;


const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <Route path="/activate" component={ActivatePage} />
        <PrivateRoute component={Dashboard} />
      </Switch>
    </BrowserRouter>
  );
};

const Dashboard = () => {
  const dialog = useSelector((state) => state.dialog);
  const { currentAgent } = useSelector((state) => state.auth);
  const { isFetching } = useSelector((state) => state.feature);

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          "profil": "KYA_LIGHT",
          "country": currentAgent.country,
          "platform": "Mobile Agent"
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        const response = await fetch('https://agent-api.wizall.com/api/features/v3/', requestOptions);
        const data = await response.json();
        const services = transformJson(data);
        const filteredData = featuresFiltered(services);
        setFeatures(filteredData);

        if (response.ok && data.success) {
          setIsLoading(false);
        } else {
          setHasError(true);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Erreur lors de l’appel API:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const transformJson = (data) => {
    return data.map(item => {
      const transformedItem = {
        id: item.id,
        title: item.title,
        route: item.route,
        order: item.order,
        icon: item.icon,
        isActive: item.isActive,
        categories: []
      };

      if (item.categories) {
        item.categories.forEach(category => {
          if (category.services && category.services.length > 0) {
            category.services.forEach(service => {
              transformedItem.categories.push({
                id: service.id,
                title: service.title === "Remboursement de prêt" ? "DER" : service.title,
                route: service.route,
                icon: service.icon,
                operator: service.operator || [],
                isActive: service.isActive
              });
            });
          } else {
            transformedItem.categories.push({
              id: category.id,
              title: category.title,
              route: category.route,
              order: category.order,
              icon: category.icon,
              isActive: category.isActive,
              services: category.services || []
            });
          }
        });
      }

      return transformedItem;
    });
  }

  return (
    <>
      <Layout>
        <TopBar />
        <Spin spinning={isFetching}>
          <Layout>
            <Sidebar features={features} />
            <Layout className="site-layout">
              <Content
                className="site-layout-background"
                style={{ margin: "24px 16px", padding: "16px" }}
              >
                <PrivateRoute exact path="/" component={HomePage} />
                <PrivateRoute path="/home" component={HomePage} />
                <PrivateRoute path="/airtime_orange_route" component={AirtimeOrange} />
                <PrivateRoute path="/airtime_expresso_route" component={AirtimeExpresso} />
                <PrivateRoute path="/airtime_yas_route" component={AirtimeFree} />
                <PrivateRoute path="/airtime_promobile_route" component={AirtimePromobile} />
                <PrivateRoute path="/airtime_moov_route" component={AirtimeMoov} />
                <PrivateRoute path="/airtime_mtn_route" component={AirtimeMtn} />
                <PrivateRoute path="/airtime_telecel_route" component={AirtimeTelecelBf} />
                <PrivateRoute path="/airtime_telemob_route" component={AirtimeTelemobBf} />
                <PrivateRoute path="/airtime_malitel_route" component={AirtimeMalitel} />
                <PrivateRoute path="/paiement_bill_senelec_route" component={BillSenelecPage} />
                <PrivateRoute path="/paiement_bill_rapido_route" component={BillRapidoPage} />
                <PrivateRoute path="/paiement_bill_seneau_route" component={BillSeneauPage} />
                <PrivateRoute path="/paiement_bill_diobass_route" component={BillDiobassPage} />
                <PrivateRoute path="/paiement_bill_toubacakanam_route" component={BillToubaCaKanamPage} />
                <PrivateRoute path="/paiement_bill_bboxx_route" component={BillBboxxPage} />
                <PrivateRoute path="/bill-dstv" component={BillDstvPage} />
                {/* <PrivateRoute path="/paiement_bill_startime_route" component={BillStartime} /> */}
                <PrivateRoute path="/paiement_bill_startime_route" component={BillCollectePage} />
                <PrivateRoute path="/paiement_bill_niirpay_route" component={BillCollectePage} />
                <PrivateRoute path="/depot_carte_client_route" component={BillCarteRoutePage} />

                <PrivateRoute path="/paiement_bill_sonabel_postpaid" component={BillSonabelPOSTPAIDPage} />
                <PrivateRoute path="/paiement_bill_sonabel_prepaid" component={BillSonabelPREPAIDPage} />
                <PrivateRoute path="/paiement_bill_woyofal_v2_route" component={BillWoyofalPage} />
                <PrivateRoute path="/bill-cosec" render={(props) => <BillOrbusPage {...props} param="COSEC" />} />
                <PrivateRoute path="/paiement_bill_orbus_route" render={(props) => <BillOrbusPage {...props} param="DP WORLD" />} />
                <PrivateRoute path="/paiement_bill_oolu_route" component={BillOoluPage} />
                <PrivateRoute path="/bill-ansamble-lfjm" component={BillAnsambleLFJMPage} />

                <PrivateRoute path="/bill-ansamble-isd" component={BillAnsambleLISDPage} />
                <PrivateRoute path="/bill-baloon-assurance" component={BillBaloonPage} />

                <PrivateRoute path="/paiement_bill_somagep_route" component={BillSomagepPage} />
                <PrivateRoute path="/paiement_game_route" component={BillMinteroutePage} />
                <PrivateRoute path="/paiement_bill_isago_route" component={BillIsagoPage} />
                <PrivateRoute path="/paiement_bill_cmacgm_route" component={BillCmacgmPage} />
                <PrivateRoute path="/bill-campusen" component={BillCampusenPage} />
                <PrivateRoute path="/bill-canal-ml" component={BillCanalPage} />
                <PrivateRoute path="/paiement_bill_agrivaucher_paiement_route" component={BillAgrivoucherPage} />
                <PrivateRoute path="/depot_collecte_onea_route" component={BillOneaPage} />
                <PrivateRoute path="/paiement_bill_agrivaucher_enlevement_route" component={BillAgrivoucherEnlevementPage} />
                <PrivateRoute path="/bill_der_agent_rembousement_pret_route" component={BillDerPage} />
                <PrivateRoute path="/paiement_bill_sodeci_route" component={BillSodeciPage} />
                <PrivateRoute path="/paiement_bill_cie_route" component={BillCiePage} />
                <PrivateRoute path="/paiement_bill_saar_agent_route" component={BillSaarPage} />
                <PrivateRoute path="/paiement_bill_faarf_route" component={BillFaarfPage} />
                <PrivateRoute path="/paiement_bill_dgid_route" component={BillDGIDPage} />
                <PrivateRoute path="/ordre_retrait_agent_route" component={CashoutProvisionPage} />
                <PrivateRoute path="/retrait_carte_route" component={CashoutCardPage} />
                <PrivateRoute path="/retrait_sms_route" component={CashoutCodePage} />
                <PrivateRoute path="/retrait_client_route" component={CashoutCostumerPage} />
                <PrivateRoute path="/retrait_more_route" component={CashoutMorePage} />
                <PrivateRoute path="/depot_collecte_collecte_route" component={CollectPage} />
                <PrivateRoute path="/depot_collecte_client_route" component={CashinPage} />
                <PrivateRoute path="/transfert" component={TransfertPage} />
                <PrivateRoute
                  path="/pincode-reset"
                  component={PinCodeResetPage}
                />
                <PrivateRoute path="/transaction" component={Transaction} />
                {/* <Redirect to="/" /> */}
              </Content>
            </Layout>
          </Layout>
        </Spin>
        {dialog.isLockscreen && <LockScreen />}
        {dialog.isSuccess && <SuccessDialog />}
        {dialog.isError && <ErrorDialog />}
        {currentAgent?.pin_setted === false && <PinSettedDialog />}
      </Layout>
    </>
  );
};

const PrivateRoute = ({ ...rest }) => {
  const auth = loadAgentState();
  return auth ? <Route {...rest} /> : <Redirect to="/login" />;
};

export default App;
